import { render, staticRenderFns } from "./ResourcesModal.vue?vue&type=template&id=41348b14&scoped=true&"
import script from "./ResourcesModal.vue?vue&type=script&lang=ts&"
export * from "./ResourcesModal.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcesModal.vue?vue&type=style&index=0&id=41348b14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41348b14",
  null
  
)

export default component.exports